<template>
  <div class="step-choices-editor">
    <div class="toolbar">
      <el-button type="primary" size="small" @click="addChoice">添加选择项</el-button>
    </div>
    <el-table :data="choices" border style="margin-top: 10px">
      <el-table-column label="序号" type="index" width="60"></el-table-column>
      <el-table-column label="文本" prop="text">
        <template slot-scope="scope">
          <el-input
            :value="scope.row.text"
            @input="updateChoice(scope.$index, 'text', $event)"
            placeholder="请输入文本"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="值" prop="value">
        <template slot-scope="scope">
          <el-input
            :value="scope.row.value"
            @input="updateChoice(scope.$index, 'value', $event)"
            placeholder="请输入值"
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column label="条件" prop="condition">
        <template slot-scope="scope">
          <el-input
            :value="scope.row.condition"
            @input="updateChoice(scope.$index, 'condition', $event)"
            placeholder="请输入条件"
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column label="确认文本" prop="confirmText">
        <template slot-scope="scope">
          <el-input
            :value="scope.row.confirmText"
            @input="updateChoice(scope.$index, 'confirmText', $event)"
            placeholder="请输入值"
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column label="作为回复" prop="asReply" width="120">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.asReply"
            @change="updateChoice(scope.$index, 'asReply', $event)"
            active-text="是"
            inactive-text="否"
          ></el-switch>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="removeChoice(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "StepChoicesEditor",
  props: {
    stepId: {
      type: String,
      required: true
    }
  },
  inject: {
    getEditingStepData: {
      from: "getEditingStepData",
      default: () => () => null
    },
    updateEditingStepField: {
      from: "updateEditingStepField",
      default: () => () => {}
    }
  },
  computed: {
    ...mapGetters("problemFlowConfig", ["steps"]),
    choices() {
      // 优先使用临时编辑状态，否则使用 store 中的数据
      const editingStepData = this.getEditingStepData();
      if (editingStepData) {
        return editingStepData.choices || [];
      }
      return this.steps[this.stepId]?.choices || [];
    }
  },
  methods: {
    updateChoices(newChoices) {
      // 优先更新临时编辑状态，否则直接更新 store
      const editingStepData = this.getEditingStepData();
      if (editingStepData) {
        this.updateEditingStepField("choices", newChoices);
      } else {
        this.$store.dispatch("problemFlowConfig/updateStepField", {
          stepId: this.stepId,
          field: "choices",
          value: newChoices
        });
      }
    },
    addChoice() {
      const choices = [...this.choices];
      choices.push({ text: "", value: "", asReply: false });
      this.updateChoices(choices);
    },
    removeChoice(index) {
      const choices = [...this.choices];
      choices.splice(index, 1);
      this.updateChoices(choices);
    },
    updateChoice(index, field, value) {
      const choices = [...this.choices];
      choices[index] = { ...choices[index], [field]: value };
      this.updateChoices(choices);
    }
  }
};
</script>

<style lang="less" scoped>
.step-choices-editor {
  padding: 10px;
}
</style>
